/* ==========================================================================
   SKÉINA SKINCARE — Kollektionsseiten
   Filter, Sortierung, mobiler Drawer, Quick-Add.
   Theme-Filter (initThemeFilter): Hautthema, Hauttyp, Wirkstoff, Produktart,
   clientseitig mit URL-Zustand. Native Filter nur ohne Theme-Filter.
 
   Bewusste Entscheidungen:
   - Kein Framework, keine Abhaengigkeit. Wird am Ende der Raster-Sektion mit
     async geladen und startet sofort, sobald die Datei da ist. Mit defer lief
     der Filter erst nach allen anderen Theme-Skripten (jQuery, GSAP, Swiper),
     auf langsamen Verbindungen 5 bis 6 Sekunden nach Seitenbeginn.
   - Hover-Bilder der Karten laden erst bei Bedarf (Maus in der Naehe) und
     auf Touch-Geraeten gar nicht.
   - Ohne JavaScript bleibt alles bedienbar: das Filterformular hat einen
     nativen Submit-Button in noscript, Quick-Add ist ein echtes POST-Formular.
   - Sektion-Rendering-API statt Full Reload, damit die Scrollposition
     beim Filtern erhalten bleibt.
   ========================================================================== */
 
(function () {
  'use strict';
 
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
 
  /* ----------------------------------------------------------------------
     Filter und Sortierung
     ---------------------------------------------------------------------- */
 
  function initFilters(root) {
    // Theme-Filter uebernimmt Filter und Sortierung selbst (initThemeFilter)
    if (root.querySelector('[data-skn-tf-panel]')) return;
    var form = root.querySelector('[data-skn-form]');
    var sort = root.querySelector('[data-skn-sort]');
    var results = root.querySelector('[data-skn-results]');
    if (!results) return;
 
    var debounceTimer = null;
 
    function buildUrl() {
      var params = new URLSearchParams();
 
      if (form) {
        new FormData(form).forEach(function (value, key) {
          if (value !== '' && value !== null) params.append(key, value);
        });
      }
      if (sort && sort.value) {
        params.delete('sort_by');
        params.append('sort_by', sort.value);
      }
 
      var base = window.location.pathname;
      var qs = params.toString();
      return qs ? base + '?' + qs : base;
    }
 
    function apply() {
      var url = buildUrl();
 
      root.setAttribute('aria-busy', 'true');
 
      fetch(url)
        .then(function (r) {
          if (!r.ok) throw new Error('Filter konnte nicht geladen werden');
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newRoot = doc.getElementById(root.id);
          if (!newRoot) {
            window.location.href = url;
            return;
          }
 
          // Ergebnisse, Toolbar und Filterpanel gezielt austauschen
          var swap = ['[data-skn-results]', '.skn-toolbar'];
          swap.forEach(function (sel) {
            var oldEl = root.querySelector(sel);
            var newEl = newRoot.querySelector(sel);
            if (oldEl && newEl) oldEl.replaceWith(newEl);
          });
 
          // Filterpanel: nur die Zaehler und Zustaende, offene Gruppen behalten
          var oldPanel = root.querySelector('[data-skn-filters]');
          var newPanel = newRoot.querySelector('[data-skn-filters]');
          if (oldPanel && newPanel) {
            var openStates = Array.prototype.map.call(
              oldPanel.querySelectorAll('details'),
              function (d) { return d.open; }
            );
            var wasOpen = oldPanel.getAttribute('data-open');
            oldPanel.replaceWith(newPanel);
            Array.prototype.forEach.call(
              newPanel.querySelectorAll('details'),
              function (d, i) { if (openStates[i] !== undefined) d.open = openStates[i]; }
            );
            if (wasOpen) newPanel.setAttribute('data-open', wasOpen);
          }
 
          window.history.replaceState({}, '', url);
          bind(root);
 
          var count = root.querySelector('[data-skn-count]');
          if (count) announce(count.textContent.trim());
        })
        .catch(function () {
          window.location.href = url;
        })
        .finally(function () {
          root.removeAttribute('aria-busy');
        });
    }
 
    function debounced() {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(apply, 350);
    }
 
    if (form) {
      form.addEventListener('change', function (e) {
        if (e.target.type === 'number') return; // Preis erst bei Blur
        apply();
      });
      form.addEventListener('input', function (e) {
        if (e.target.type === 'number') debounced();
      });
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        apply();
      });
    }
 
    if (sort) sort.addEventListener('change', apply);
  }
 
  /* ----------------------------------------------------------------------
     Theme-Filter (clientseitig)
     Daten je Karte am <li data-skn-item>: data-tf-tags (Tags ohne __label,
     mit | getrennt), data-tf-type (product.type), data-tf-skin (Labels aus
     shopify.suitable-for-skin-type). Innerhalb einer Gruppe ODER, zwischen
     Gruppen UND. Zustand in der URL: ?thema=roetungen,unreinheiten&wirkstoff=niacinamid
     ---------------------------------------------------------------------- */

  var TF_THEMES = [
    { slug: 'roetungen', label: 'Rötungen & empfindliche Haut', tags: ['Rötungen', 'Empfindliche Haut', 'Gereizte Haut'] },
    { slug: 'unreinheiten', label: 'Unreinheiten & Poren', tags: ['Unreinheiten', 'Poren', 'Mischhaut', 'Fettige Haut'] },
    { slug: 'linien', label: 'Linien & Spannkraft', tags: ['Anti-Aging', 'Spannkraft', 'Feine Linien'] },
    { slug: 'reinigung', label: 'Reinigung', tags: ['Reinigung', 'Make-up-Entferner'] }
  ];
  var TF_SKIN_ALL = 'alle-hauttypen';
  var TF_SKIN_ORDER = ['empfindlich', 'problem', 'fettig', 'kombination', 'normal', 'trocken'];
  var TF_SKIN_DISPLAY = { problem: 'Problemhaut', kombination: 'Mischhaut' };
  var TF_ART_ORDER = ['essence', 'serum', 'mizellenwasser', 'set', 'routine'];
  var TF_GROUPS = [
    { key: 'thema', label: 'Hautthema' },
    { key: 'hauttyp', label: 'Hauttyp' },
    { key: 'wirkstoff', label: 'Wirkstoff' },
    { key: 'art', label: 'Produktart' }
  ];

  function tfSlug(s) {
    return String(s || '').trim().toLowerCase()
      .replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss')
      .normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  function tfSplit(s) {
    return String(s || '').split('|').map(function (x) { return x.trim(); })
      .filter(function (x) { return x && x.indexOf('__label') === -1; });
  }

  function initThemeFilter(root) {
    var panel = root.querySelector('[data-skn-tf-panel]');
    if (!panel || panel.dataset.bound === 'true') return;
    panel.dataset.bound = 'true';

    var groupsEl = panel.querySelector('[data-skn-tf-groups]');
    var openBtn = root.querySelector('[data-skn-tf-open]');
    var closeBtn = panel.querySelector('[data-skn-tf-close]');
    var applyBtn = panel.querySelector('[data-skn-tf-apply]');
    var overlay = root.querySelector('[data-skn-tf-overlay]');
    var badge = root.querySelector('[data-skn-tf-badge]');
    var chipsEl = root.querySelector('[data-skn-tf-chips]');
    var live = panel.querySelector('[data-skn-tf-live]');
    var sort = root.querySelector('[data-skn-sort]');
    var mq = window.matchMedia('(max-width: 989px)');

    var activeSlugs = {};
    (panel.getAttribute('data-actives') || '').split(',').forEach(function (a) {
      var t = a.trim();
      if (t) activeSlugs[tfSlug(t)] = t;
    });
    var themeByTag = {};
    TF_THEMES.forEach(function (t) {
      t.tags.forEach(function (tag) { themeByTag[tfSlug(tag)] = t.slug; });
    });

    var items = [];
    var options = {};     // key -> [{ slug, label }]
    var labels = {};      // key -> { slug: label }
    var state = {};       // key -> [slugs]
    TF_GROUPS.forEach(function (g) { state[g.key] = []; labels[g.key] = {}; });

    function readItems() {
      items = Array.prototype.map.call(root.querySelectorAll('[data-skn-item]'), function (li) {
        var sets = { thema: {}, hauttyp: {}, wirkstoff: {}, art: {} };
        var skinAll = false;
        var tags = tfSplit(li.getAttribute('data-tf-tags'));
        tags.forEach(function (tag) {
          var sl = tfSlug(tag);
          if (themeByTag[sl]) sets.thema[themeByTag[sl]] = true;
          if (activeSlugs[sl]) { sets.wirkstoff[sl] = true; labels.wirkstoff[sl] = tag; }
        });
        tfSplit(li.getAttribute('data-tf-skin')).forEach(function (lbl) {
          var sl = tfSlug(lbl);
          if (sl === TF_SKIN_ALL) { skinAll = true; return; }
          sets.hauttyp[sl] = true;
          labels.hauttyp[sl] = TF_SKIN_DISPLAY[sl] || lbl;
        });
        var type = (li.getAttribute('data-tf-type') || '').trim();
        if (type) {
          sets.art[tfSlug(type)] = true;
          labels.art[tfSlug(type)] = type;
        } else {
          // Fallback, falls product.type leer ist: Produktart-Tags
          tags.forEach(function (tag) {
            var sl = tfSlug(tag);
            if (TF_ART_ORDER.indexOf(sl) > -1) { sets.art[sl] = true; labels.art[sl] = tag; }
          });
        }
        return { li: li, sets: sets, skinAll: skinAll };
      });
    }

    function orderBy(list, order) {
      return list.sort(function (a, b) {
        var ia = order.indexOf(a.slug), ib = order.indexOf(b.slug);
        if (ia === -1) ia = 999;
        if (ib === -1) ib = 999;
        return ia - ib || a.label.localeCompare(b.label, 'de');
      });
    }

    function buildOptions() {
      TF_THEMES.forEach(function (t) { labels.thema[t.slug] = t.label; });
      var activeOrder = Object.keys(activeSlugs);
      TF_GROUPS.forEach(function (g) {
        var seen = {};
        items.forEach(function (it) {
          Object.keys(it.sets[g.key]).forEach(function (sl) { seen[sl] = true; });
        });
        var list = Object.keys(seen).map(function (sl) { return { slug: sl, label: labels[g.key][sl] || sl }; });
        if (g.key === 'thema') list = orderBy(list, TF_THEMES.map(function (t) { return t.slug; }));
        else if (g.key === 'hauttyp') list = orderBy(list, TF_SKIN_ORDER);
        else if (g.key === 'wirkstoff') list = orderBy(list, activeOrder);
        else list = orderBy(list, TF_ART_ORDER);

        // Eine Option, die jedes Produkt hat, filtert nichts: Gruppe weglassen
        if (list.length === 1) {
          var all = items.every(function (it) { return itemHas(it, g.key, list[0].slug); });
          if (all) list = [];
        }
        options[g.key] = list;
      });
    }

    function itemHas(it, key, slug) {
      if (key === 'hauttyp' && it.skinAll) return true;
      return !!it.sets[key][slug];
    }

    function matches(it, except) {
      return TF_GROUPS.every(function (g) {
        if (g.key === except) return true;
        var sel = state[g.key];
        if (!sel.length) return true;
        return sel.some(function (sl) { return itemHas(it, g.key, sl); });
      });
    }

    function activeTotal() {
      return TF_GROUPS.reduce(function (n, g) { return n + state[g.key].length; }, 0);
    }

    /* Ab so vielen Optionen wird eine Gruppe gekuerzt ("+ 5 weitere").
       Gruppen mit bis zu LIMIT + 1 Optionen bleiben ganz sichtbar, ein
       "+ 1 weitere" spart keinen Platz. */
    var LIMIT = 6;
    var openGroups = {};

    function renderGroups() {
      var html = '';
      var first = true;
      TF_GROUPS.forEach(function (g) {
        var list = options[g.key];
        if (!list || !list.length) return;
        var hasActive = state[g.key].length > 0;
        if (openGroups[g.key] === undefined) openGroups[g.key] = first || hasActive;
        first = false;
        var isOpen = openGroups[g.key];
        var btnId = panel.id + '-' + g.key + '-btn';
        var bodyId = panel.id + '-' + g.key + '-body';
        var clip = list.length > LIMIT + 1;
        html += '<div class="skn-tf__group' + (isOpen ? ' is-open' : '') + (clip ? ' is-clipped' : '') + '" data-group="' + g.key + '">'
          + '<h3 class="skn-tf__gh"><button class="skn-tf__toggle" type="button" id="' + btnId + '" aria-expanded="' + isOpen + '" aria-controls="' + bodyId + '" data-tf-toggle="' + g.key + '">'
          + '<span class="skn-tf__gname">' + escHtml(g.label) + '</span>'
          + '<span class="skn-tf__gcount" data-gcount hidden></span>'
          + '<span class="skn-tf__chev" aria-hidden="true"></span>'
          + '</button></h3>'
          + '<div class="skn-tf__gbody" id="' + bodyId + '" role="group" aria-labelledby="' + btnId + '"><div class="skn-tf__ginner">'
          + '<div class="skn-tf__opts">';
        list.forEach(function (o, i) {
          html += '<label class="skn-tf__opt' + (clip && i >= LIMIT ? ' skn-tf__opt--extra' : '') + '">'
            + '<input class="skn-tf__cb" type="checkbox" name="' + g.key + '" value="' + escHtml(o.slug) + '">'
            + '<span class="skn-tf__tick" aria-hidden="true"></span>'
            + '<span class="skn-tf__opt-label">' + escHtml(o.label) + '</span>'
            + '<span class="skn-tf__opt-count" data-count></span>'
            + '</label>';
        });
        html += '</div>';
        if (clip) {
          html += '<button class="skn-tf__more" type="button" data-tf-more="' + g.key + '" aria-expanded="false"></button>';
        }
        html += '</div></div></div>';
      });
      groupsEl.innerHTML = html;
    }

    function setGroupOpen(key, open) {
      openGroups[key] = open;
      var grp = groupsEl.querySelector('[data-group="' + key + '"]');
      if (!grp) return;
      grp.classList.toggle('is-open', open);
      var btn = grp.querySelector('[data-tf-toggle]');
      if (btn) btn.setAttribute('aria-expanded', String(open));
      scheduleSticky();
    }

    /* --- Sticky nur, wenn die Sidebar ganz in den Viewport passt --- */
    var deskMq = window.matchMedia('(min-width: 990px)');
    var stickyTimer = null;

    function headerOffset() {
      // Der Theme-Header ist sticky, --header-height ist aber nicht gesetzt.
      // Deshalb echte Hoehe messen, sonst rutschen Leiste und Filter darunter.
      var hdr = document.querySelector('.shopify-section-group-header-group[id$="skn_header"], [id^="shopify-section-"][id$="__skn_header"]');
      if (!hdr) return 0;
      var cs = window.getComputedStyle(hdr);
      if (cs.position !== 'sticky' && cs.position !== 'fixed') return 0;
      var r = hdr.getBoundingClientRect();
      return Math.max(0, Math.round(r.height));
    }

    function checkSticky() {
      var hdr = headerOffset();
      root.style.setProperty('--skn-sticky-top', hdr + 'px');
      if (!deskMq.matches) { panel.classList.remove('is-sticky'); return; }
      var top = hdr + 20;
      panel.style.setProperty('--skn-tf-top', top + 'px');
      var fits = panel.scrollHeight + top + 16 <= window.innerHeight;
      panel.classList.toggle('is-sticky', fits);
    }

    function scheduleSticky() {
      clearTimeout(stickyTimer);
      // nach der Auf-/Zuklapp-Transition messen
      stickyTimer = setTimeout(checkSticky, REDUCED ? 0 : 280);
    }

    function escHtml(s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    /* --- URL --- */
    function readUrl() {
      var params = new URLSearchParams(window.location.search);
      TF_GROUPS.forEach(function (g) {
        var raw = params.get(g.key);
        var valid = (options[g.key] || []).map(function (o) { return o.slug; });
        state[g.key] = raw
          ? raw.split(',').map(tfSlug).filter(function (sl, i, arr) {
              return sl && valid.indexOf(sl) > -1 && arr.indexOf(sl) === i;
            })
          : [];
      });
    }

    function baseParams() {
      var params = new URLSearchParams(window.location.search);
      TF_GROUPS.forEach(function (g) { params.delete(g.key); });
      params.delete('section_id');
      return params;
    }

    function filterQuery() {
      return TF_GROUPS.filter(function (g) { return state[g.key].length; })
        .map(function (g) { return g.key + '=' + state[g.key].join(','); })
        .join('&');
    }

    function writeUrl() {
      var rest = baseParams().toString();
      var own = filterQuery();
      var qs = [rest, own].filter(Boolean).join('&');
      var url = window.location.pathname + (qs ? '?' + qs : '') + window.location.hash;
      try { window.history.replaceState(window.history.state, '', url); } catch (e) { /* still */ }
    }

    /* --- Anzeige --- */
    var running = [];
    var animToken = 0;

    function show(visible, animate) {
      var token = ++animToken;
      running.forEach(function (a) { try { a.cancel(); } catch (e) {} });
      running = [];

      var bundle = root.querySelector('[data-skn-bundle]');
      if (bundle) bundle.hidden = activeTotal() > 0;

      var canAnimate = animate && !REDUCED && typeof Element.prototype.animate === 'function';
      if (!canAnimate) {
        items.forEach(function (it, i) { it.li.hidden = !visible[i]; });
        return;
      }

      var leaving = [], entering = [], staying = [];
      items.forEach(function (it, i) {
        if (!it.li.hidden && !visible[i]) leaving.push(it.li);
        else if (it.li.hidden && visible[i]) entering.push(it.li);
        else if (!it.li.hidden) staying.push(it.li);
      });

      var outs = leaving.map(function (li) {
        var a = li.animate(
          [{ opacity: 1, transform: 'scale(1)' }, { opacity: 0, transform: 'scale(0.96)' }],
          { duration: 160, easing: 'cubic-bezier(0.4, 0, 1, 1)', fill: 'forwards' }
        );
        running.push(a);
        return a.finished.catch(function () {});
      });

      Promise.all(outs).then(function () {
        if (token !== animToken) return;
        var first = staying.map(function (li) { return li.getBoundingClientRect(); });
        items.forEach(function (it, i) { it.li.hidden = !visible[i]; });
        running.forEach(function (a) { try { a.cancel(); } catch (e) {} });
        running = [];

        staying.forEach(function (li, i) {
          var last = li.getBoundingClientRect();
          var dx = first[i].left - last.left, dy = first[i].top - last.top;
          if (!dx && !dy) return;
          running.push(li.animate(
            [{ transform: 'translate(' + dx + 'px,' + dy + 'px)' }, { transform: 'none' }],
            { duration: 320, easing: 'cubic-bezier(0.16, 1, 0.3, 1)' }
          ));
        });
        entering.forEach(function (li, n) {
          running.push(li.animate(
            [{ opacity: 0, transform: 'translateY(10px) scale(0.98)' }, { opacity: 1, transform: 'none' }],
            { duration: 300, delay: Math.min(n * 35, 175), easing: 'cubic-bezier(0.16, 1, 0.3, 1)', fill: 'backwards' }
          ));
        });
      });
    }

    function productWord(n) { return n === 1 ? 'Produkt' : 'Produkte'; }

    function update(opts) {
      opts = opts || {};
      var visible = items.map(function (it) { return matches(it, null); });
      var shown = visible.filter(Boolean).length;
      var total = items.length;
      var active = activeTotal();

      // Optionen: Zustand, Anzahl, deaktiviert
      Array.prototype.forEach.call(groupsEl.querySelectorAll('.skn-tf__cb'), function (cb) {
        var key = cb.name, slug = cb.value;
        var checked = state[key].indexOf(slug) > -1;
        var n = items.filter(function (it) { return matches(it, key) && itemHas(it, key, slug); }).length;
        cb.checked = checked;
        cb.disabled = !checked && n === 0;
        var lab = cb.closest('.skn-tf__opt');
        lab.classList.toggle('is-checked', checked);
        lab.classList.toggle('is-disabled', cb.disabled);
        lab.querySelector('[data-count]').textContent = n;
      });

      // Pro Gruppe: Anzahl aktiver Optionen und "+ N weitere"
      Array.prototype.forEach.call(groupsEl.querySelectorAll('[data-group]'), function (grp) {
        var key = grp.getAttribute('data-group');
        var n = state[key].length;
        var gc = grp.querySelector('[data-gcount]');
        if (gc) { gc.textContent = n; gc.hidden = n === 0; }
        var more = grp.querySelector('[data-tf-more]');
        if (more) {
          var expanded = grp.classList.contains('is-more');
          var hiddenN = grp.querySelectorAll('.skn-tf__opt--extra:not(.is-checked)').length;
          more.hidden = hiddenN === 0 && !expanded;
          more.textContent = expanded ? 'Weniger anzeigen' : '+ ' + hiddenN + ' weitere';
          more.setAttribute('aria-expanded', String(expanded));
        }
      });

      // Zaehler in der Toolbar (Desktop) und ueber dem Raster (Mobil)
      Array.prototype.forEach.call(root.querySelectorAll('[data-skn-count]'), function (countEl) {
        countEl.textContent = active
          ? shown + ' von ' + total + ' Produkten'
          : total + ' ' + productWord(total);
      });

      if (badge) {
        badge.textContent = active;
        badge.hidden = active === 0;
      }
      if (openBtn) {
        openBtn.setAttribute('aria-label', active ? 'Filtern, ' + active + ' aktiv' : 'Filtern');
      }
      if (applyBtn) applyBtn.textContent = shown + ' ' + productWord(shown) + ' anzeigen';

      Array.prototype.forEach.call(root.querySelectorAll('[data-skn-tf-reset]'), function (b) {
        if (b.closest('[data-skn-tf-empty]') || b.closest('.skn-tf__foot')) return;
        b.hidden = active === 0;
      });
      var footReset = panel.querySelector('.skn-tf__foot [data-skn-tf-reset]');
      if (footReset) footReset.disabled = active === 0;

      renderChips();

      var empty = root.querySelector('[data-skn-tf-empty]');
      if (empty) empty.hidden = shown > 0;

      show(visible, opts.animate);
      if (opts.writeUrl !== false) writeUrl();
      if (opts.announce && live) {
        live.textContent = shown === 0
          ? 'Keine Produkte für diese Auswahl'
          : shown + ' ' + productWord(shown) + ' gefunden';
      }
    }

    function renderChips() {
      if (!chipsEl) return;
      var html = '';
      TF_GROUPS.forEach(function (g) {
        state[g.key].forEach(function (sl) {
          var lbl = labels[g.key][sl] || sl;
          html += '<li><button class="skn-chip" type="button" data-tf-remove="' + g.key + ':' + escHtml(sl) + '">'
            + escHtml(lbl)
            + '<span class="skn-chip__x" aria-hidden="true">&times;</span>'
            + '<span class="skn-c__visually-hidden">Filter entfernen</span></button></li>';
        });
      });
      if (html) {
        html += '<li><button class="skn-chip skn-chip--reset" type="button" data-skn-tf-reset>Filter zurücksetzen</button></li>';
      }
      chipsEl.innerHTML = html;
      chipsEl.hidden = !html;
    }

    function toggle(key, slug, on) {
      var list = state[key];
      var i = list.indexOf(slug);
      if (on && i === -1) list.push(slug);
      if (!on && i > -1) list.splice(i, 1);
    }

    function reset() {
      TF_GROUPS.forEach(function (g) { state[g.key] = []; });
      update({ animate: true, announce: true });
    }

    /* --- Mobiles Bottom-Sheet --- */
    var lastFocus = null;

    function isOpen() { return panel.getAttribute('data-open') === 'true'; }

    function openSheet() {
      if (!mq.matches) return;
      lastFocus = document.activeElement;
      panel.setAttribute('data-open', 'true');
      panel.setAttribute('role', 'dialog');
      panel.setAttribute('aria-modal', 'true');
      if (overlay) {
        overlay.hidden = false;
        // Reflow, damit die Einblendung animiert
        void overlay.offsetWidth;
        overlay.setAttribute('data-open', 'true');
      }
      if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('skn-tf-lock');
      document.addEventListener('keydown', onKey);
      setTimeout(function () { if (closeBtn) closeBtn.focus(); }, REDUCED ? 0 : 60);
    }

    function closeSheet(restoreFocus) {
      if (!isOpen()) return;
      panel.removeAttribute('data-open');
      panel.removeAttribute('role');
      panel.removeAttribute('aria-modal');
      if (overlay) {
        overlay.removeAttribute('data-open');
        setTimeout(function () { if (!isOpen()) overlay.hidden = true; }, REDUCED ? 0 : 320);
      }
      if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('skn-tf-lock');
      document.removeEventListener('keydown', onKey);
      if (restoreFocus !== false && lastFocus && lastFocus.focus) lastFocus.focus();
    }

    function onKey(e) {
      if (e.key === 'Escape') { closeSheet(); return; }
      if (e.key !== 'Tab') return;
      var f = Array.prototype.filter.call(
        panel.querySelectorAll('button, input, [href], [tabindex]:not([tabindex="-1"])'),
        function (el) { return !el.disabled && !el.hidden && el.offsetParent !== null; }
      );
      if (!f.length) return;
      var firstEl = f[0], lastEl = f[f.length - 1];
      if (e.shiftKey && document.activeElement === firstEl) { e.preventDefault(); lastEl.focus(); }
      else if (!e.shiftKey && document.activeElement === lastEl) { e.preventDefault(); firstEl.focus(); }
    }

    /* --- Sortierung: serverseitig, Filterzustand bleibt erhalten --- */
    function onSort() {
      var params = baseParams();
      params.delete('page');
      if (sort.value) params.set('sort_by', sort.value); else params.delete('sort_by');
      var own = filterQuery();
      var qs = [params.toString(), own].filter(Boolean).join('&');
      var pageUrl = window.location.pathname + (qs ? '?' + qs : '');
      var sectionId = root.getAttribute('data-section-id');
      if (!sectionId) { window.location.href = pageUrl; return; }
      var fetchUrl = pageUrl + (qs ? '&' : '?') + 'section_id=' + encodeURIComponent(sectionId);

      root.setAttribute('aria-busy', 'true');
      fetch(fetchUrl, { credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-skn-results]');
          var old = root.querySelector('[data-skn-results]');
          if (!fresh || !old) throw new Error('Kein Ergebnisbereich');
          old.replaceWith(fresh);
          readItems();
          initQuickAdd(root);
          try { window.history.replaceState(window.history.state, '', pageUrl); } catch (e) {}
          update({ animate: false, writeUrl: false });
          if (live) live.textContent = 'Sortierung aktualisiert';
        })
        .catch(function () { window.location.href = pageUrl; })
        .finally(function () { root.removeAttribute('aria-busy'); });
    }

    /* --- Start --- */
    readItems();
    if (!items.length) {
      panel.hidden = true;
      return;
    }
    buildOptions();
    var hasGroups = TF_GROUPS.some(function (g) { return options[g.key].length; });
    if (!hasGroups) {
      panel.hidden = true;
      var layout = root.querySelector('.skn-layout');
      if (layout) layout.classList.add('skn-layout--full');
      return;
    }
    renderGroups();
    readUrl();
    // Gruppen mit aktiven Filtern aus der URL offen zeigen
    TF_GROUPS.forEach(function (g) {
      if (state[g.key].length && !openGroups[g.key]) {
        openGroups[g.key] = true;
        var grp = groupsEl.querySelector('[data-group="' + g.key + '"]');
        if (grp) {
          grp.classList.add('is-open');
          grp.querySelector('[data-tf-toggle]').setAttribute('aria-expanded', 'true');
        }
      }
    });
    panel.classList.add('is-ready');
    if (openBtn) openBtn.hidden = false;
    update({ animate: false, writeUrl: activeTotal() > 0 });
    checkSticky();
    window.addEventListener('resize', scheduleSticky, { passive: true });
    window.addEventListener('load', checkSticky);
    if (deskMq.addEventListener) deskMq.addEventListener('change', checkSticky);

    groupsEl.addEventListener('click', function (e) {
      var tg = e.target.closest('[data-tf-toggle]');
      if (tg) {
        var key = tg.getAttribute('data-tf-toggle');
        setGroupOpen(key, !openGroups[key]);
        return;
      }
      var more = e.target.closest('[data-tf-more]');
      if (more) {
        var grp = more.closest('[data-group]');
        var willExpand = !grp.classList.contains('is-more');
        grp.classList.toggle('is-more', willExpand);
        update({ animate: false, writeUrl: false });
        if (willExpand) {
          var firstExtra = grp.querySelector('.skn-tf__opt--extra .skn-tf__cb');
          if (firstExtra) firstExtra.focus();
        }
        scheduleSticky();
      }
    });

    groupsEl.addEventListener('change', function (e) {
      var cb = e.target;
      if (!cb.classList || !cb.classList.contains('skn-tf__cb')) return;
      toggle(cb.name, cb.value, cb.checked);
      update({ animate: true, announce: true });
    });

    root.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-tf-remove]');
      if (rm) {
        var parts = rm.getAttribute('data-tf-remove').split(':');
        toggle(parts[0], parts[1], false);
        update({ animate: true, announce: true });
        var next = chipsEl && chipsEl.querySelector('button');
        if (next) next.focus();
        else if (openBtn && mq.matches) openBtn.focus();
        return;
      }
      if (e.target.closest('[data-skn-tf-reset]')) {
        // Fokus nicht verlieren, wenn der geklickte Button beim Neuaufbau verschwindet
        var fromOutside = !!e.target.closest('[data-skn-tf-empty], [data-skn-tf-chips], .skn-tf__head');
        reset();
        if (fromOutside) {
          var target = mq.matches ? (isOpen() ? closeBtn : openBtn) : groupsEl.querySelector('[data-tf-toggle]');
          if (target) target.focus({ preventScroll: true });
        }
      }
    });

    if (openBtn) openBtn.addEventListener('click', openSheet);
    if (closeBtn) closeBtn.addEventListener('click', function () { closeSheet(); });
    if (overlay) overlay.addEventListener('click', function () { closeSheet(); });
    if (applyBtn) {
      applyBtn.addEventListener('click', function () {
        closeSheet(false);
        var results = root.querySelector('[data-skn-results]');
        if (results) {
          var top = results.getBoundingClientRect().top + window.pageYOffset - 140;
          if (top < window.pageYOffset) window.scrollTo({ top: Math.max(top, 0), behavior: REDUCED ? 'auto' : 'smooth' });
        }
        if (openBtn) openBtn.focus({ preventScroll: true });
      });
    }
    var onMq = function () { if (!mq.matches) closeSheet(false); };
    if (mq.addEventListener) mq.addEventListener('change', onMq); else if (mq.addListener) mq.addListener(onMq);

    if (sort) {
      sort.addEventListener('change', onSort);
    }
  }

  /* ----------------------------------------------------------------------
     Mobiler Filter-Drawer
     ---------------------------------------------------------------------- */
 
  function initDrawer(root) {
    var panel = root.querySelector('[data-skn-filters]');
    var overlay = root.querySelector('[data-skn-overlay]');
    var openBtn = root.querySelector('[data-skn-filter-open]');
    var closeBtn = root.querySelector('[data-skn-filter-close]');
    if (!panel || !openBtn) return;
 
    var lastFocus = null;
 
    function open() {
      lastFocus = document.activeElement;
      panel.setAttribute('data-open', 'true');
      if (overlay) { overlay.hidden = false; overlay.setAttribute('data-open', 'true'); }
      openBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      if (closeBtn) closeBtn.focus();
      document.addEventListener('keydown', onKey);
    }
 
    function close() {
      panel.removeAttribute('data-open');
      if (overlay) {
        overlay.removeAttribute('data-open');
        setTimeout(function () { overlay.hidden = true; }, REDUCED ? 0 : 200);
      }
      openBtn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      if (lastFocus) lastFocus.focus();
      document.removeEventListener('keydown', onKey);
    }
 
    function onKey(e) { if (e.key === 'Escape') close(); }
 
    openBtn.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (overlay) overlay.addEventListener('click', close);
  }
 
  /* ----------------------------------------------------------------------
     Quick-Add
     ---------------------------------------------------------------------- */
 
  function initQuickAdd(root) {
    root.querySelectorAll('[data-skn-add]').forEach(function (form) {
      if (form.dataset.bound === 'true') return;
      form.dataset.bound = 'true';
 
      form.addEventListener('submit', function (e) {
        e.preventDefault();
 
        var btn = form.querySelector('button[type="submit"]');
        var err = form.querySelector('[data-skn-error]');
        var idle = form.querySelector('[data-label-idle]');
        var done = form.querySelector('[data-label-done]');
 
        if (err) err.textContent = '';
        if (btn) btn.setAttribute('data-state', 'loading');
 
        fetch(window.Shopify && window.Shopify.routes
          ? window.Shopify.routes.root + 'cart/add.js'
          : '/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            items: [{
              id: parseInt(form.querySelector('[name="id"]').value, 10),
              quantity: 1
            }]
          })
        })
          .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.data.description || res.data.message || 'Fehler');
 
            if (btn) btn.setAttribute('data-state', 'done');
            if (idle) idle.hidden = true;
            if (done) done.hidden = false;
            announce('Zum Warenkorb hinzugefügt');
 
            refreshCart();
 
            setTimeout(function () {
              if (btn) btn.setAttribute('data-state', 'idle');
              if (idle) idle.hidden = false;
              if (done) done.hidden = true;
            }, 2500);
          })
          .catch(function (error) {
            if (btn) btn.setAttribute('data-state', 'idle');
            if (err) err.textContent = error.message || 'Konnte nicht hinzugefügt werden.';
          });
      });
    });
  }
 
  /* Warenkorb-Anzeige aktualisieren. Deckt die gaengigen Theme-Muster ab
     und faellt sonst still zurueck — kein harter Reload. */
  function refreshCart() {
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
 
    fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll(
          '.cart-count, .cart-count-bubble span, [data-cart-count], .header__cart-count'
        ).forEach(function (el) {
          el.textContent = cart.item_count;
          el.classList.remove('hidden');
        });
        document.dispatchEvent(new CustomEvent('skn:cart:updated', { detail: cart, bubbles: true }));
      })
      .catch(function () { /* still */ });
  }
 
  /* ----------------------------------------------------------------------
     Hover-Bilder: erst laden, wenn sie gebraucht werden
     Vorher lud jede Karte zwei Bilder, auch auf Handys ohne Hover.
     Jetzt: nur Geraete mit Maus. Sofort beim Ueberfahren, und nach dem
     Seitenladen still fuer Karten in Sichtweite.
     ---------------------------------------------------------------------- */

  var CAN_HOVER = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function loadHover(card) {
    if (!card || card.dataset.hoverLoaded) return;
    var img = card.querySelector('img[data-hover-srcset]');
    if (!img) return;
    card.dataset.hoverLoaded = 'true';
    img.addEventListener('load', function () { card.classList.add('is-hover-ready'); }, { once: true });
    img.sizes = img.getAttribute('data-hover-sizes') || img.sizes;
    img.srcset = img.getAttribute('data-hover-srcset');
    img.src = img.getAttribute('data-hover-src');
  }

  function initHoverImages(root) {
    if (!CAN_HOVER) return;
    root.addEventListener('pointerover', function (e) {
      var card = e.target.closest && e.target.closest('.skn-card');
      if (card) loadHover(card);
    });
    function idle() {
      if (!('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { loadHover(en.target); io.unobserve(en.target); }
        });
      }, { rootMargin: '200px 0px' });
      root.querySelectorAll('.skn-card').forEach(function (c) { io.observe(c); });
    }
    var later = function () {
      if ('requestIdleCallback' in window) window.requestIdleCallback(idle, { timeout: 3000 });
      else setTimeout(idle, 1500);
    };
    if (document.readyState === 'complete') later();
    else window.addEventListener('load', later, { once: true });
  }

  /* ----------------------------------------------------------------------
     Screenreader-Ansage
     ---------------------------------------------------------------------- */
 
  var liveRegion = null;
  function announce(message) {
    if (!liveRegion) {
      liveRegion = document.createElement('p');
      liveRegion.setAttribute('aria-live', 'polite');
      liveRegion.setAttribute('role', 'status');
      liveRegion.className = 'skn-c__visually-hidden';
      document.body.appendChild(liveRegion);
    }
    liveRegion.textContent = message;
  }
 
  /* ----------------------------------------------------------------------
     Bootstrap
     ---------------------------------------------------------------------- */
 
  function bind(root) {
    if (root.dataset.sknBound === 'true') return;
    root.dataset.sknBound = 'true';
    initFilters(root);
    initThemeFilter(root);
    initDrawer(root);
    initQuickAdd(root);
    initHoverImages(root);
  }
 
  function boot() {
    document.querySelectorAll('[id^="skn-collection-"]').forEach(bind);
  }
 
  // Async am Ende der Sektion: das Markup steht schon, also sofort starten.
  // Fallback fuer den Fall, dass die Datei anderswo frueher eingebunden wird.
  boot();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  }
 
  // Theme-Editor: Sektion neu geladen
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[id^="skn-collection-"]');
    if (root) { root.dataset.sknBound = ''; bind(root); }
  });
})();
 
